import React from "react";
import { Link } from "react-router-dom";
import { PUBLIC_PLANS } from "../../lib/publicSite";

export default function Pricing() {
  return (
    <section className="max-w-7xl mx-auto px-6 py-16">
      <div className="text-center max-w-2xl mx-auto">
        <h1 className="font-display font-bold text-3xl sm:text-4xl">Simple, honest pricing</h1>
        <p className="mt-3 text-lg" style={{ color: "var(--text-muted)" }}>Start free for 14 days. Cancel any time. All prices in INR.</p>
      </div>
      <div className="mt-10 grid md:grid-cols-3 gap-6">
        {PUBLIC_PLANS.map((p) => (
          <div
            key={p.name}
            className={`card-soft p-7 ${p.highlight ? "ring-2" : ""}`}
            style={p.highlight ? { boxShadow: "0 12px 40px rgba(139,30,63,0.15)", borderColor: "var(--primary)" } : {}}
            data-testid={`landing-plan-${p.name.toLowerCase()}`}
          >
            <div className="font-display font-semibold text-xl">{p.name}</div>
            <div className="mt-3 flex items-baseline gap-1">
              <span className="font-display font-bold text-4xl num">₹{p.price}</span>
              <span className="text-sm" style={{ color: "var(--text-muted)" }}>/month</span>
            </div>
            <ul className="mt-5 space-y-2 text-sm">
              {p.features.map((f) => (
                <li key={f} className="flex items-start gap-2"><span style={{ color: "var(--success)" }}>✓</span> {f}</li>
              ))}
            </ul>
            <Link
              to="/register"
              className="mt-6 block text-center py-3 rounded-md font-semibold tactile-btn text-white"
              style={{ background: p.highlight ? "var(--primary)" : "var(--secondary)" }}
            >
              Choose {p.name}
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}
